<template>
	<div>
		<v-navigation-drawer fixed v-model="navStateFilter" :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list dense>
				<v-list-item>
					<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search"></v-text-field>
				</v-list-item>
				<v-list-item>
					<v-menu v-model="dataordine" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
						<template v-slot:activator="{ on }">
							<v-text-field hide-details="auto" :value="computedDatejs" v-on="on" dense clearable @click:clear="cleardate" label="Data ordine"> </v-text-field>
						</template>
						<v-date-picker v-model="settings.filters.created_at" @change="dataordine = false" range></v-date-picker>
					</v-menu>
				</v-list-item>
				<v-list-item>
					<v-menu v-model="datapreparazione" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
						<template v-slot:activator="{ on }">
							<v-text-field hide-details="auto" :value="computedDatePrepjs" v-on="on" dense clearable @click:clear="cleardate" label="Data preparazione"> </v-text-field>
						</template>
						<v-date-picker v-model="settings.filters.preparation_date" @change="datapreparazione = false" range></v-date-picker>
					</v-menu>
				</v-list-item>
				<v-list-item>
					<v-select hide-details="auto" v-model="settings.filters.platform" :items="platform" :menu-props="{ maxHeight: '400' }" multiple dense label="Platform"></v-select>
				</v-list-item>
				<v-list-item>
					<v-select hide-details="auto" v-model="settings.filters.payments" :items="payments" :menu-props="{ maxHeight: '400' }" multiple dense label="Payment"></v-select>
				</v-list-item>
				<v-list-item>
					<v-select hide-details="auto" v-model="settings.filters.status" :items="status" :menu-props="{ maxHeight: '400' }" multiple dense label="Status"></v-select>
				</v-list-item>

				<v-list-item>
					<v-select hide-details="auto" v-model="settings.filters.agents" :items="agents" :menu-props="{ maxHeight: '400' }" multiple dense label="Agente"></v-select>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.listOrderAgents') }}</v-toolbar-title>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--<v-btn text :href="linkdownload+'?search='+searchfield+'&categories='+settings.filters.categories+'&selected='+selected" exact >
                    <v-icon>mdi-arrow-collapse-down</v-icon>
                </v-btn>-->

								<v-btn
									text
									@click="exportAsync('orders', 'csv', { search: searchfield, payments: settings.filters.payments, created_at: settings.filters.created_at, platform: settings.filters.platform, status: settings.filters.status, selected: selectedchecbox })"
									exact
								>
									<v-icon>mdi-arrow-collapse-down</v-icon>
								</v-btn>

								<!-- <v-divider vertical></v-divider>-->
								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>

								<!-- <v-divider vertical></v-divider>-->
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text @click="openNew">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>
									<v-list elevation="0">
										<v-list-item @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi ordine</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>

									<!--<v-list elevation="0">
                      <v-list-item @click="getCategoryMagento">
                          <v-list-item-icon>
                              <v-icon>mdi-plus</v-icon>
                          </v-list-item-icon>

                          <v-list-item-content>
                              <v-list-item-title>Importa da Magento</v-list-item-title>
                          </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="getFileCategories">
                          <v-list-item-icon>
                              <v-icon>mdi-plus</v-icon>
                          </v-list-item-icon>

                          <v-list-item-content>
                              <v-list-item-title>Importa da file esterno</v-list-item-title>
                          </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="createItem">
                          <v-list-item-icon>
                              <v-icon>mdi-plus</v-icon>
                          </v-list-item-icon>

                          <v-list-item-content>
                              <v-list-item-title>Aggiungi categoria</v-list-item-title>
                          </v-list-item-content>
                      </v-list-item>
                  </v-list>-->
								</v-menu>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>

						<v-card v-if="selectedchecbox.length > 0" elevation="0" outlined>
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selectedchecbox.length }}
									<span v-if="selectedchecbox.length === 1" style="margin-left: 1rem"> selezionato </span>
									<span v-else style="margin-left: 1rem"> selezionati </span>
								</v-tab>

								<v-tab @click="editItem" v-if="selectedchecbox.length === 1"> modifica </v-tab>
								<v-tab
									@click="exportAsync('orders', 'csv', { search: searchfield, payments: settings.filters.payments, created_at: settings.filters.created_at, platform: settings.filters.platform, status: settings.filters.status, selected: selectedchecbox })"
								>
									Download
								</v-tab>
								<v-tab @click="eliminaCorrispettivo" v-if="InvoiceItem && TypeInvoice === 'Ricevuta' && selectedchecbox.length === 1 && fattureincloud"> Elimina Corrispettivo </v-tab>
								<v-tab @click="eliminaFattura" v-if="InvoiceItem && TypeInvoice === 'Fattura' && selectedchecbox.length === 1 && fattureincloud"> Elimina Fattura </v-tab>
								<v-tab @click="creaCorrispettivo" v-if="!InvoiceItem && selectedchecbox.length === 1 && fattureincloud"> Crea Corrispettivo </v-tab>
								<v-tab @click="creaFattura" v-if="!InvoiceItem && selectedchecbox.length === 1 && fattureincloud"> Crea Fattura </v-tab>
								<v-tab @click="creaOrdineFornitore" v-if="checkInPreparazione && selectedchecbox.length >= 1"> Invia in preparazione </v-tab>
								<v-tab @click="annullaOrdineFornitore" v-if="checkRollbackInPreparazione && selectedchecbox.length >= 1"> Annulla preparazione </v-tab>
							</v-tabs>
						</v-card>
						<!--<v-toolbar
                    dark

                    elevation="0"
                    color="primary"
                    v-if="selectedchecbox.length>0"
            >

                <v-toolbar-title>
                    <h5 class="font-weight-regular">{{ selectedchecbox.length }}
                        <span v-if="selectedchecbox.length==1">
                            selezionato
                        </span>
                        <span v-else>
                            selezionati
                        </span>
                        <v-divider vertical></v-divider>


                    </h5>


                </v-toolbar-title>
                <v-divider vertical class="mx-4"></v-divider>
                <template v-if="selectedchecbox.length==1">
                <v-btn class="ml-0 text-lowercase"
                       elevation="0"
                       text

                       @click="editItem"
                >modifica
                </v-btn>
                    &lt;!&ndash;TypeInvoice:'',
                    InvoiceItem:'',&ndash;&gt;
                <span v-if="InvoiceItem">
                        <v-btn class="ml-0 text-lowercase" elevation="0" text @click="eliminaCorrispettivo" v-if="TypeInvoice=='Ricevuta'">Elimina Corrispettivo</v-btn>
                        <v-btn class="ml-0 text-lowercase" elevation="0" text @click="eliminaFattura" v-if="TypeInvoice=='Fattura'">Elimina Fattura</v-btn>
                </span>
                <span v-else>
                    <v-btn class="ml-0 text-lowercase" elevation="0" text @click="creaCorrispettivo">Crea Corrispettivo</v-btn>
                    <v-btn class="ml-0 text-lowercase" elevation="0" text @click="creaFattura">Crea Fattura</v-btn>
                </span>
                </template>
                <template v-else>
                &lt;!&ndash;<v-btn class="ml-0 text-lowercase"
                       elevation="0"
                       text
                       @click="deleteItem"


                >elimina
                </v-btn>&ndash;&gt;
                </template>
                <v-btn class="ml-0 text-lowercase" elevation="0" text @click="exportAsync('orders', 'csv', { search: searchfield, payments: settings.filters.payments, created_at: settings.filters.created_at, platform: settings.filters.platform, status: settings.filters.status, selected: selectedchecbox })">Download</v-btn>
                &lt;!&ndash;<v-list-item @click="editItem(item)"  >
                    <v-list-item-title  >Dettaglio</v-list-item-title>

                </v-list-item>
                <div v-if="item.Invoice.Number">
                    <v-list-item @click="eliminaCorrispettivo(item)" v-if="item.Invoice.Name=='Ricevuta'" >
                        <v-list-item-title>Elimina Corrispettivo</v-list-item-title>

                    </v-list-item>
                    <v-list-item @click="eliminaFattura(item)" v-if="item.Invoice.Name=='Fattura'" >
                        <v-list-item-title>Elimina Fattura</v-list-item-title>

                    </v-list-item>
                </div>
                <div v-else>
                    <v-list-item @click="creaCorrispettivo(item)"  >
                        <v-list-item-title>Crea Corrispettivo</v-list-item-title>

                    </v-list-item>
                    <v-list-item @click="creaFattura(item)"  >
                        <v-list-item-title>Crea Fattura</v-list-item-title>

                    </v-list-item>
                </div>&ndash;&gt;


            </v-toolbar>-->

						<v-data-table
							v-model="selectedall"
							:headers="headers"
							:items="getOrders"
							:options.sync="settings.options"
							:server-items-length="total"
							class="elevation-0 cellanowrap"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							show-select
							@input="toggle"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<!--:hide-default-header="isMobile"-->

							<template v-slot:body="{ items }">
								<!-- telefono: ogni ordine diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="agent-order-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length + 1" class="px-3 py-1">
											<key-value-card :title="item.OrderID || 'Ordine'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-checkbox class="mt-0 mr-0 pr-0 pt-0" v-model="selectedchecbox" :value="item._id" color="primary" hide-details></v-checkbox>
													<v-btn small icon color="primary" :title="checkpresenza(item._id) ? 'Chiudi' : 'Mostra prodotti e indirizzo'" @click="extension(item._id)">
														<v-icon>{{ checkpresenza(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
													<v-menu
														:disabled="disabled"
														:absolute="absolute"
														:open-on-hover="openOnHover"
														:close-on-click="closeOnClick"
														:close-on-content-click="closeOnContentClick"
														:offset-x="offsetX"
														:offset-y="offsetY"
													>
														<template v-slot:activator="{ on }">
															<v-btn icon small elevation="0" :color="item.Color || 'grey'" v-on="on">
																<v-icon>mdi-tag</v-icon>
															</v-btn>
														</template>
														<v-list dense>
															<v-list-item v-for="color in coloriTag" :key="color">
																<v-btn @click="changeStatus(item, color)" elevation="0" icon :color="color"><v-icon>mdi-tag</v-icon></v-btn>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div v-if="nomeCliente(item)" class="order-buyer mb-1">{{ nomeCliente(item) }}</div>
													<div class="d-flex align-center flex-wrap mb-1">
														<v-avatar size="26px" tile class="mr-2">
															<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" />
														</v-avatar>
														<v-avatar size="16px" tile class="mr-2" v-if="item.ShippingAddress && item.ShippingAddress.Country">
															<img :src="getImageFlag(item.ShippingAddress)" :alt="item.ShippingAddress.Country" />
														</v-avatar>
														<v-avatar size="26px" tile class="mr-2" title="Pagamento">
															<img :src="getImagePayment(item.Checkout.StatusPayment)" :alt="item.Platform" />
														</v-avatar>
														<v-avatar size="26px" tile class="mr-2" title="Spedizione">
															<img :src="getImageShip(item)" />
														</v-avatar>
														<v-avatar size="26px" tile class="mr-2" title="Fattura">
															<img v-if="item.Invoice && item.Invoice.Number && fattureincloud" :src="require(`@/assets/images/fattureincloud_active.svg`)" />
															<img v-else :src="require(`@/assets/images/fattureincloud.svg`)" />
														</v-avatar>
														<v-avatar v-if="_.trim(item.Message) !== ''" size="26px" tile class="mr-2" title="Ordine contiene delle note">
															<img :src="require(`@/assets/images/mail.svg`)" />
														</v-avatar>
													</div>
													<div class="d-flex align-center flex-wrap mb-1">
														<v-chip v-if="item.StatusOrder && item.StatusOrder.value" small label class="mr-2 mb-1">{{ item.StatusOrder.value }}</v-chip>
														<v-chip v-if="item.Buy" small outlined color="success" class="mr-2 mb-1" title="Margine">
															{{ (scorporoiva(item.Total, item.BuyVat) - item.Buy - item.Fee - item.Transaction.FeeOrCreditAmount).toFixed(2) }}
														</v-chip>
														<v-chip v-if="item.Refund" small outlined color="error" class="mr-2 mb-1" title="Netto dopo il rimborso">
															{{ (item.Total - item.Refund - item.Fee - item.Transaction.FeeOrCreditAmount).toFixed(2) }}
														</v-chip>
													</div>
												</template>
												<template v-if="checkpresenza(item._id)">
													<div class="order-section">Prodotti acquistati</div>
													<div v-for="(prod, i) in item.Items" :key="'p' + i" class="order-line">
														<div class="font-weight-medium">{{ prod.Title || 'Prodotto' }}</div>
														<div class="order-kv">
															<span>SKU</span><span class="order-kv-v">{{ prod.SKU || '-' }}</span>
														</div>
														<div class="order-kv">
															<span>ID</span><span class="order-kv-v">{{ prod.ItemID || '-' }}</span>
														</div>
														<div v-if="prod.Attribute" class="order-kv">
															<span>Variante</span><span class="order-kv-v">{{ prod.Attribute }}</span>
														</div>
														<div class="order-kv">
															<span>Qtà</span><span class="font-weight-bold">{{ prod.QuantityPurchased }}</span>
														</div>
														<div class="order-kv">
															<span>Prezzo</span><span class="font-weight-bold">{{ prod.TransactionPrice }}</span>
														</div>
													</div>
													<div v-if="!(item.Items || []).length" class="grey--text">Nessun prodotto</div>
													<div class="order-section mt-3">Dati di spedizione</div>
													<div class="order-line">
														<div v-for="riga in righeIndirizzo(item.ShippingAddress)" :key="riga.label" class="order-kv">
															<span>{{ riga.label }}</span>
															<span class="d-flex align-center">
																<span class="order-kv-v">{{ riga.value }}</span>
																<v-btn x-small icon class="ml-1" title="Copia" @click="copy(riga.copia)">
																	<v-icon x-small>mdi-content-copy</v-icon>
																</v-btn>
															</span>
														</div>
														<div v-if="!righeIndirizzo(item.ShippingAddress).length" class="grey--text">Nessun indirizzo</div>
													</div>
												</template>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length + 1" class="grey--text text-center py-4">Nessun elemento</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="(item, index) in items">
										<tr :key="`${item._id}${_.random(1, 10000)}`">
											<!-- v-bind:class="toggleClass(1)"-->
											<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->
											<td>
												<v-checkbox class="mt-0 mr-0 pr-0" v-model="selectedchecbox" :value="item._id" color="primary" hide-details></v-checkbox>
											</td>
											<td>
												<v-btn small icon @click="extension(item._id)">
													<v-icon v-if="!checkpresenza(item._id)">mdi-plus</v-icon>
													<v-icon v-else>mdi-minus</v-icon>
												</v-btn>
											</td>
											<td>{{ item.created_at | moment('DD/MM/YYYY HH:mm:ss') }}</td>
											<td>{{ item.OrderID }}</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" />
												</v-avatar>
												<v-avatar size="16px" tile style="margin-left: 5px" v-if="item.ShippingAddress.Country">
													<img :src="getImageFlag(item.ShippingAddress)" :alt="item.ShippingAddress" />
												</v-avatar>
											</td>
											<td>{{ item.buyer.name }}</td>
											<td>{{ item.buyer.lastname }}</td>

											<td>
												<v-avatar size="32px" tile>
													<img :src="getImagePayment(item.Checkout.StatusPayment)" :alt="item.Platform" />
												</v-avatar>
											</td>
											<td>{{ item.OrderStatus }}</td>
											<td>
												<span v-if="item.StatusOrder">{{ item.StatusOrder.value }}</span>
											</td>
											<td>{{ item.preparation_date != undefined || item.preparation_date != null ? new Date(item.preparation_date).toLocaleDateString() : 'n.d.' }}</td>
											<td class="text-right">
												<v-chip v-if="item.Buy" class="ma-2" color="success" outlined x-small>
													{{ (scorporoiva(item.Total, item.BuyVat) - item.Buy - item.Fee - item.Transaction.FeeOrCreditAmount).toFixed(2) }}
												</v-chip>
												<v-chip v-if="item.Refund" class="ma-2" color="error" outlined x-small>
													{{ (item.Total - item.Refund - item.Fee - item.Transaction.FeeOrCreditAmount).toFixed(2) }}
												</v-chip>
												{{ item.Total }} {{ item.Currency }}
											</td>

											<td class="text-right">{{ item.agent ? item.agent.name : '' }} {{ item.agent ? item.agent.lastname : '' }}</td>
											<td class="text-right">{{ item.agent ? item.agent.percentage : '' }}</td>
											<td class="text-right">{{ item.Refund }}</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="getImageShip(item)" />
												</v-avatar>
											</td>
											<td>
												<div v-if="item.Invoice && item.Invoice.Number && fattureincloud">
													<v-avatar size="32px" tile>
														<img :src="require(`@/assets/images/fattureincloud_active.svg`)" />
													</v-avatar>
												</div>
												<div v-else>
													<v-avatar size="32px" tile>
														<img :src="require(`@/assets/images/fattureincloud.svg`)" />
													</v-avatar>
												</div>
												<v-avatar v-if="_.trim(item.Message) !== ''" size="32px" tile>
													<img :src="require(`@/assets/images/mail.svg`)" />
												</v-avatar>
											</td>

											<td width="120">
												<v-menu
													:disabled="disabled"
													:absolute="absolute"
													:open-on-hover="openOnHover"
													:close-on-click="closeOnClick"
													:close-on-content-click="closeOnContentClick"
													:offset-x="offsetX"
													:offset-y="offsetY"
												>
													<template v-slot:activator="{ on }">
														<v-btn icon small elevation="0" :color="item.Color || 'grey'" v-on="on">
															<v-icon>mdi-tag</v-icon>
														</v-btn>
													</template>
													<v-list dense>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'red')" elevation="0" icon color="red"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'pink')" elevation="0" icon color="pink"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'purple')" elevation="0" icon color="purple"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'indigo')" elevation="0" icon color="indigo"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'blue')" elevation="0" icon color="blue"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'green')" elevation="0" icon color="green"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'yellow')" elevation="0" icon color="yellow"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'orange')" elevation="0" icon color="orange"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'grey')" elevation="0" icon color="grey"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
										</tr>
										<tr class="active" v-if="checkpresenza(item._id)" v-for="(prod, index) in item.Items" :key="item._id">
											<!-- v-bind:class="toggleClass(2)"      v-if="item.hide"-->
											<td></td>
											<td>{{ prod.SKU }}</td>
											<td>{{ prod.ItemID }}</td>
											<td>
												{{ prod.Attribute }}
											</td>
											<td colspan="5">{{ prod.Title }}</td>
											<td>{{ prod.QuantityPurchased }}</td>
											<td class="text-right">{{ prod.TransactionPrice }}</td>
											<td></td>
											<td colspan="6"></td>
										</tr>
										<tr class="active" v-if="checkpresenza(item._id)">
											<!-- v-bind:class="toggleClass(2)"      v-if="item.hide"-->
											<td></td>
											<td colspan="2">
												{{ item.ShippingAddress.Name }}
												<v-btn class="ma-2" small icon @click="copy(item.ShippingAddress.Name)">
													<v-icon>mdi-content-copy</v-icon>
												</v-btn>
											</td>
											<td colspan="3">
												{{ item.ShippingAddress.Street1 }} {{ item.ShippingAddress.Street2 }}
												<v-btn class="ma-2" small icon @click="copy(item.ShippingAddress.Street1)">
													<v-icon>mdi-content-copy</v-icon>
												</v-btn>
											</td>
											<td>
												{{ item.ShippingAddress.CityName }}
												<v-btn class="ma-2" small icon @click="copy(item.ShippingAddress.CityName)">
													<v-icon>mdi-content-copy</v-icon>
												</v-btn>
											</td>
											<td colspan="2">
												{{ item.ShippingAddress.PostalCode }}
												<v-btn class="ma-2" small icon @click="copy(item.ShippingAddress.PostalCode)">
													<v-icon>mdi-content-copy</v-icon>
												</v-btn>
											</td>
											<td colspan="2">
												{{ item.ShippingAddress.StateOrProvince }}
												<v-btn class="ma-2" small icon @click="copy(item.ShippingAddress.StateOrProvince)">
													<v-icon>mdi-content-copy</v-icon>
												</v-btn>
											</td>
											<td colspan="2">
												{{ item.ShippingAddress.Country }}
												<v-btn class="ma-2" small icon @click="copy(item.ShippingAddress.Country)">
													<v-icon>mdi-content-copy</v-icon>
												</v-btn>
											</td>

											<td colspan="3">
												{{ item.ShippingAddress.Phone }}
												<v-btn class="ma-2" small icon @click="copy(item.ShippingAddress.Phone)">
													<v-icon>mdi-content-copy</v-icon>
												</v-btn>
											</td>
											<td></td>
											<td></td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormEdit v-if="operation === 'FormEdit'" :key="componentKey" @message="propSetMessages"></FormEdit>
			<FormCreate v-if="operation === 'FormCreate'" :key="componentKey" @message="propSetMessages"></FormCreate>
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Seri sicuro?</v-card-title>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="secondary" @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogOrderSupplier" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="text-h5">Seleziona una data</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<p>Indica una data entro cui tutti gli articoli presenti negli ordini selezionati saranno consegnati</p>
								<v-date-picker v-model="dateOrderSupplier" full-width locale="it-it" landscape :first-day-of-week="1"></v-date-picker>
							</v-col>
						</v-row>
					</v-container>
					<small>*Campi obbligatori</small>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click="dialogOrderSupplier = false"> Annulla </v-btn>
					<v-btn color="blue darken-1" text @click="inviaOrdineFornitore"> Invia </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';

import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { openWithReturn } from '@/components/core/pageReturn';

const FormCreate = () => import('@/components/orders_agents/Create.vue');
const FormEdit = () => import('@/components/orders_agents/Edit.vue');

export default {
	name: 'OrderAgents',
	data() {
		return {
			componentKey: 0,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					preparation_date: [],
					payments: [],
					agents: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},

			listSize: [15, 25, 50, 100],
			linkdownload: '',
			searchfield: '',
			selected: [],
			selectedchecbox: [],
			selectedall: [],

			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: '', value: '' },
				{ text: 'Date', value: 'created_at' },
				{ text: 'Order Id', value: 'OrderID' },
				{ text: 'Platform', value: 'Platform' },
				{ text: 'Nome', value: 'buyer.name' },
				{ text: 'Cognome', value: 'buyer.lastname' },
				/*{text: 'Email',     value: 'buyer.email' },*/
				{ text: 'Method', value: 'Checkout.PaymentMethods' },
				{ text: 'Status Ex', value: 'OrderStatus' },
				{ text: 'Status', value: 'Status' },
				{ text: 'Data preparazione', value: 'preparation_date' },
				{ text: 'Price', value: 'Total' },
				{ text: 'Agent', value: 'agent' },
				{ text: 'Agent %', value: 'agent.percentage' },
				{ text: 'Refund', value: 'Refund' },
				{ text: 'Ship', value: 'Invoice' },
				{ text: 'Invoice', value: 'Items' },
				{ text: 'Azioni', value: '', sortable: false },
			],

			// colori del tag ordine (stessa lista del menu desktop)
			coloriTag: ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			parseDate: [],
			dataordine: '',
			datapreparazione: '',
			platform: [],
			status: [],
			payments: [],
			agents: [],
			choosePlaform: [],
			chooseStatus: [],
			choosePayments: [],
			Totale: 0,
			Fee: 0,
			Refund: 0,
			Gain: 0,
			page: 1,
			isMobile: false,

			//Invoice Fattureincloud
			TypeInvoice: '',
			InvoiceItem: '',
			magento: false,
			shopify: false,
			prestashop: false,
			woocommerce: false,
			fattureincloud: false,
			dialogOrderSupplier: false,
			dateOrderSupplier: '',
			checkInPreparazione: true,
			checkRollbackInPreparazione: false,
			operation: '',
		};
	},
	/*created () {
      this.setDialog(false)
      this.initialize();

  },*/
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},

	created() {},
	mounted() {
		//this.setDialog(false)
		//this.initialize();
		this.setDialog(false);
		this.setExistFilter(true);
		this.linkdownload = `${this.getUrl}orders/download`;
		this.updateEnableAgents(true);

		this.fetchSetting().then(data => {
			let magento = _.find(data.settings, { service: 'magento', active: true });
			if (magento) {
				this.magento = magento.active;
				this.platform.push('Magento');
			}
			let shopify = _.find(data.settings, { service: 'shopify', active: true });
			if (shopify) {
				this.shopify = shopify.active;
				this.platform.push('Shopify');
			}
			let aliexpress = _.find(data.settings, { service: 'aliexpress', active: true });
			if (aliexpress) {
				this.aliexpress = aliexpress.active;
				this.platform.push('Aliexpress');
			}
			let prestashop = _.find(data.settings, { service: 'prestashop', active: true });
			if (prestashop) {
				this.prestashop = prestashop.active;
				this.platform.push('Prestashop');
			}
			let woocommerce = _.find(data.settings, { service: 'woocommerce', active: true });
			if (woocommerce) {
				this.woocommerce = woocommerce.active;
				this.platform.push('Woocommerce');
			}
			let paypal = _.find(data.settings, { service: 'paypal', active: true });
			if (paypal) {
				this.payments.push({ text: 'Paypal', value: 'Paypal' });
			}
			let stripe = _.find(data.settings, { service: 'stripe', active: true });

			if (stripe) {
				this.payments.push({ text: 'Stripe', value: 'Stripe' });
			}
			let fattureincloud = _.find(data.settings, { service: 'fattureInCloud', active: true });
			if (fattureincloud) {
				this.fattureincloud = fattureincloud.active;
			}

			let mws = _.find(data.settings, { service: 'mws', active: true });
			if (mws) {
				this.platform.push('Amazon');
			}

			let ebay = _.find(data.settings, { service: 'ebay', active: true });
			if (ebay) {
				this.platform.push('Ebay');
			}

			this.platform.push('Store');

			this.fetchStatusOrder().then(result => {
				//console.log(result)
				_.forEach(result.data, el => {
					var textStatus = _.find(el.trans, { lang: this.getLanguage });

					this.status.push({ text: textStatus.value, value: el._id });
				});
			});

			this.fetchPaymentMethod().then(result => {
				_.forEach(result.data, el => {
					this.payments.push({ text: el.value, value: el._id });
				});
			});

			this.fetchAgentMethod().then(result => {
				_.forEach(result.data, el => {
					this.agents.push({ text: el.info.name + ' ' + el.info.lastname, value: el._id });
				});
			});
		});

		this.$root.$on('updateOrdersList', () => {
			this.getDataFromApi();
		});
	},
	watch: {
		selectedLength(val, oldVal) {
			//console.log(val)
			if (val > 0) {
				//_.set(this.selectedall,'[0]',1)
				//_.assign(this.selectedall[0],1)
				this.selectedall = [-1];
			}
		},
		selectedchecbox(val, oldval) {
			if (this.selectedchecbox.length === 1) {
				let el = this.selectedchecbox[0];
				let item = _.find(this.getOrders, i => {
					return i._id === el;
				});
				if (item) {
					if (item.Invoice && item.Invoice.Number) {
						if (item.Invoice.Name === 'Ricevuta') {
							this.TypeInvoice = 'Ricevuta';
						}
						if (item.Invoice.Name === 'Fattura') {
							this.TypeInvoice = 'Fattura';
						}
						this.InvoiceItem = true;
					} else {
						this.InvoiceItem = false;
					}

					if (item.Status === 'In Preparazione') {
						this.checkInPreparazione = false;
						this.checkRollbackInPreparazione = true;
					}
				}
			} else {
				this.checkInPreparazione = true;

				_.forEach(this.selectedchecbox, ord => {
					let item = _.find(this.getOrders, i => {
						return i._id === ord;
					});
					if (item) {
						if (item.Status === 'In Preparazione') {
							this.checkInPreparazione = false;
							this.checkRollbackInPreparazione = true;
						}
					}
				});
			}
		},
		settings: {
			handler(val) {
				if (_.isUndefined(this.settings.options.sortBy[0]) && this.settings.options.sortBy[0] !== '') {
					var outcome = this.getSortDesc;
					outcome = !outcome;
					this.settings.options.sortBy = [];
					this.settings.options.sortDesc = [];
					this.settings.options.sortBy.push(this.getSortBy);
					this.settings.options.sortDesc.push(outcome);
				}
				if (val.options.page === this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.options.page;
				/*if(this.setinterval){
            clearInterval(this.setinterval)
        }*/
				this.getDataFromApi();
			},
			deep: true,
		},
	},
	components: {
		FormCreate,
		FormEdit,
		KeyValueCard,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		selectedLength() {
			return this.selectedchecbox.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getOrders: 'orders/getOrders',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'orders/getIndex',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'orders/getSortBy',
			getSortDesc: 'orders/getSortDesc',
			getLanguage: 'profile/getLanguage',
		}),
		/*Totale(){
        console.log(filteredItems)
        /!*if(filteredItems.length>0) {
            return filteredItems.reduce((total, current) => {
                return total + parseFloat(current.Total)
            })

        }*!/
    },*/
		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
		filteredItems() {
			var filters = this.getOrders;

			filters = filters.filter(d => {
				//console.log("fine",moment(this.parseDate[1]+" 23:59:59").utc().format());
				if (this.parseDate.length === 1) {
					return (
						d.created_at >
						moment(this.parseDate[0] + ' 00:00:00')
							.utc()
							.format()
					);
				}
				if (this.parseDate.length === 2) {
					//console.log("inizio",moment(this.parseDate[0]+" 00:00:00").utc().format());
					//return moment(d.created_at).utc().format()  < moment(this.parseDate[0]+" 00:00:00").utc().format() && moment(d.created_at).utc().format() > moment(this.parseDate[1]+" 23:59:59").utc().format()
					return (
						d.created_at >
							moment(this.parseDate[0] + ' 00:00:00')
								.utc()
								.format() &&
						d.created_at <
							moment(this.parseDate[1] + ' 23:59:59')
								.utc()
								.format()
					);
					//filters.push(d.created_at > moment(this.parseDate[0]+" 00:00:00").utc().format() && d.created_at < moment(this.parseDate[1]+" 23:59:59").utc().format());
				}
				return d;
			});

			filters = filters.filter(d => {
				//console.log(this.choosePlaform)
				if (this.choosePlaform.length > 0) {
					return this.choosePlaform.includes(d.Platform);
					//filters.push(this.choosePlaform.includes(d.Platform))
				}
				return d;
			});
			filters = filters.filter(d => {
				//console.log(this.choosePlaform)
				if (this.chooseStatus.length > 0) {
					return this.chooseStatus.includes(d.Status);
					//filters.push(this.choosePlaform.includes(d.Platform))
				}
				return d;
			});
			filters = filters.filter(d => {
				//console.log(this.choosePlaform)
				if (this.choosePayments.length > 0) {
					return this.choosePayments.includes(d.Checkout.PaymentMethods);
					//filters.push(this.choosePlaform.includes(d.Platform))
				}
				return d;
			});
			//this.Totale=12.4
			if (filters.length > 0) {
				var sum = filters.reduce((total, current) => total + current.Total, 0);

				this.Totale = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				var sum = filters.reduce((total, current) => total + current.Refund, 0);

				this.Refund = parseFloat(sum, 2).toFixed(2);
			}
			//console.log(filters)
			if (filters.length > 0) {
				var total = 0;
				var refund = 0;
				filters.forEach(value => {
					if (value.Buy) {
						total += this.scorporoiva(value.Total, value.BuyVat) - value.Buy - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
					if (value.Refund) {
						//refund += value.Total-value.Buy-value.Fee-value.Transaction.FeeOrCreditAmount
						refund += value.Total - value.Refund - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
				});
				this.Gain = parseFloat(total + refund, 2).toFixed(2);
			}

			return filters;

			//return datafilter
			/*return this.getOrders.filter(d => {
          return Object.keys(this.filters).every(f => {
              return this.filters[f].length < 1 || this.filters[f].includes(d[f])
          })
      })*/
		},

		computedDatejs() {
			var arrayDate = [];
			if (this.settings.filters.created_at.length > 0) {
				this.settings.filters.created_at.forEach(value => {
					// console.log(value)
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
			//return this.parseDate ? moment(this.parseDate).format('DD/MM/YYYY') : ''
		},
		computedDatePrepjs() {
			var arrayDate = [];
			if (this.settings.filters.preparation_date.length > 0) {
				this.settings.filters.preparation_date.forEach(value => {
					// console.log(value)
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
			//return this.parseDate ? moment(this.parseDate).format('DD/MM/YYYY') : ''
		},
		/*dynamicComponent(){
        if(this.operation!=""){
            return this.operation
        }else{
            return ""
        }

    },*/
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setOrders: 'orders/setOrders',
			setOrder: 'orders/setOrder',
			setIndex: 'orders/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchOrders: 'orders/asyncFetchData',
			fetchReports: 'orders/asyncFetchReportData',
			destroyData: 'orders/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			createSupplierOrders: 'orders/createSupplierOrders',
			fetchStatusOrder: 'statusorders/fetchLists',
			fetchPaymentMethod: 'paymentmethods/fetchLists',
			fetchAgentMethod: 'agents/fetchLists',
			updateEnableAgents: 'orders/updateEnableAgents',
			//'resetMessages' : 'settings/resetMessages'
		}),
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.selectedchecbox = [];
			this.operation = '';
		},
		async creaOrdineFornitore() {
			this.dialogOrderSupplier = true;
		},
		async inviaOrdineFornitore() {
			this.dialogOrderSupplier = false;
			this.preload = true;
			let orders_id = this.selectedchecbox;
			var payload = { order_date: this.dateOrderSupplier, order_ids: orders_id };
			var response = await this.createSupplierOrders(payload);

			if (response.result === true && response.all_transformed) {
				await this.fetchOrders(this.settings);
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con  successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
			} else if (response.result === true && !response.all_transformed) {
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con successo, ma alcuni prodotti non hanno un fornitore associato';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
			} else {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore durante invio in preparazione';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
			}
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'FormCreate';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		changeStatus(item, color) {
			let url = 'orders/updatestatus';
			var payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, color: color }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					console.log(data.data);

					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					Object.assign(this.getOrders[this.editIndex], { Color: color });
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(item)
		},
		onResize() {
			if (window.innerWidth < 769) this.isMobile = true;
			else this.isMobile = false;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selectedchecbox = [];
			} else {
				//console.log(this.selected[0])
				if (event[0] != -1) {
					this.selectedchecbox = [];
					_.forEach(this.getOrders, cat => {
						this.selectedchecbox.push(cat._id);
					});
				}
			}
		},
		/*toggleAll () {


        if (this.selected.length) this.selected = []
        else this.selected = this.getOrders.slice()


    },*/
		/*changeSort (column) {
        if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending
        } else {
            this.pagination.sortBy = column
            this.pagination.descending = false
        }
    },*/
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},
		// nome e cognome del cliente per la card (vista telefono)
		nomeCliente(item) {
			return [item.buyer?.name, item.buyer?.lastname].filter(Boolean).join(' ');
		},
		// coppie chiave/valore della card ordine (vista telefono); i campi opzionali vuoti non si mostrano
		campiCard(item) {
			const agente = item.agent ? [item.agent.name, item.agent.lastname].filter(Boolean).join(' ') : '';
			const campi = [
				{ label: 'Data', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') : '', fisso: true },
				{ label: 'Status Ex', value: item.OrderStatus || '' },
				{ label: 'Preparazione', value: item.preparation_date ? new Date(item.preparation_date).toLocaleDateString() : 'n.d.', fisso: true },
				{ label: 'Totale', value: `${item.Total} ${item.Currency || ''}`.trim(), strong: true, fisso: true },
				{ label: 'Agente', value: agente },
				{ label: 'Agente %', value: item.agent ? item.agent.percentage : '', strong: true },
				{ label: 'Rimborso', value: item.Refund || '', strong: true },
			];
			return campi.filter(c => c.fisso || (c.value !== '' && c.value !== undefined && c.value !== null)).map(({ label, value, strong }) => ({ label, value, strong }));
		},
		// righe non vuote dell'indirizzo di spedizione; si copia lo stesso valore del pulsante desktop
		righeIndirizzo(indirizzo) {
			if (!indirizzo) return [];
			const campi = [
				{ label: 'Nome', key: 'Name' },
				{ label: 'Indirizzo', key: 'Street1', extra: 'Street2' },
				{ label: 'Città', key: 'CityName' },
				{ label: 'CAP', key: 'PostalCode' },
				{ label: 'Provincia', key: 'StateOrProvince' },
				{ label: 'Nazione', key: 'Country' },
				{ label: 'Telefono', key: 'Phone' },
			];
			return campi
				.filter(c => indirizzo[c.key])
				.map(c => ({
					label: c.label,
					value: c.extra && indirizzo[c.extra] ? `${indirizzo[c.key]} ${indirizzo[c.extra]}` : indirizzo[c.key],
					copia: indirizzo[c.key],
				}));
		},
		copy(field) {
			var input = document.createElement('input');

			input.setAttribute('value', field);
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
		},
		scorporoiva(totale, iva) {
			var sc = 0;
			if (!iva || iva == 0) {
				iva = 22;
				iva = iva / 100;
				iva += 1;

				sc = parseFloat(totale / iva).toFixed(2);
			} else {
				sc = totale;
				//sc=100000
			}
			return sc;
		},
		cleardate() {
			this.parseDate = [];
			this.settings.filters.created_at = [];
			this.settings.filters.preparation_date = [];
		},
		async editItem() {
			this.componentKey += 1;
			let el = this.selectedchecbox[0];
			let item = _.find(this.getOrders, i => {
				return i._id === el;
			});

			this.setClearError({});

			this.operation = 'FormEdit';
			this.setIndex(this.getOrders.indexOf(item));
			this.setOrder(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		/*checkInvoice(){
        console.log("ssssssssssssssssssssdentro")
        let el = this.selectedchecbox[0]
        let item = _.find(this.getOrders,i => {
            return i._id==el
        })
        if(item){
            if(item.Invoice.Number){
                console.log("true")
                return true
            }else{
                console.log("false")
                return false
            }
        }

    },*/
		toggleClass(num) {
			if (num === 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},
		resetForm() {
			this.form._id = '';
			this.form.name = '';
			this.form.email = '';
			this.form.password = '';
			this.form.action = '';
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 3) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;
				this.settings.filters.enableAgents = true;

				let items = this.fetchOrders(this.settings);
				items.then(result => {
					this.total = result.total;
					//this.items = result.data.data
					this.setPreload(false);
					this.selectedchecbox = [];
					this.selectedall = [];
				});
				let reports = this.fetchReports(this.settings).then(result => {
					//console.log(result.data.data)
					if (result.data.data) {
						this.Totale = result.data.data.total;
						this.Fee = result.data.data.TotalFee;
						this.Refund = result.data.data.refund;
						this.Gain = result.data.data.gain;
					}
				});
				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.componentKey += 1;

			this.setClearError({});

			this.operation = 'FormCreate';
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		creaCorrispettivo(key) {
			// il documento si crea in una pagina; Annulla/Salva tornano qui
			const id = key && key._id ? key._id : this.selectedchecbox[0];
			if (id) openWithReturn(this, { path: `/fattureincloud/${id}/corrispettivo` }, { label: 'Torna agli ordini agente' });
		},
		extension(item) {
			var prova = this.selected.includes(item);
			if (!prova) {
				this.selected.push(item);
			} else {
				var indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}

			/*this.selected.push(item)

          if (!this.getOrders[item].hide) {
              this.getOrders[item].hide = true;
          } else  {
              this.getOrders[item].hide = false;
          }*/
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		creaFattura(key) {
			// il documento si crea in una pagina; Annulla/Salva tornano qui
			const id = key && key._id ? key._id : this.selectedchecbox[0];
			if (id) openWithReturn(this, { path: `/fattureincloud/${id}/fattura` }, { label: 'Torna agli ordini agente' });
		},
		eliminaCorrispettivo() {
			let el = this.selectedchecbox[0];
			let item = _.find(this.getOrders, i => {
				return i._id === el;
			});

			let url = 'fattureincloud/eliminaCorrispettivi';
			var payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//  console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		eliminaFattura() {
			let el = this.selectedchecbox[0];
			let item = _.find(this.getOrders, i => {
				return i._id === el;
			});
			let url = 'fattureincloud/eliminaFattura';
			var payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.snackbar = true;
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;

						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		annullaOrdineFornitore() {
			let el = this.selectedchecbox[0];
			let item = _.find(this.getOrders, i => {
				return i._id === el;
			});
			let url = 'orders-suppliers/rollback';
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, { order_id: item.OrderID.toString() }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.getDataFromApi();
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.snackbar = true;
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;

						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		getImagePayment(img) {
			if (!img) {
				return require(`@/assets/images/Other.svg`);
			}
			let defaultImage = '@/assets/images/Other.svg'; // just set default
			let path = `@/assets/images/${img.value}.svg`;

			try {
				return require(`@/assets/images/${img.value}.svg`);
			} catch (e) {
				return require(`@/assets/images/Other.svg`);
			}
		},
		getImageShip(item) {
			if (item.ShippedTime) {
				return require(`@/assets/images/box_ship.svg`);
			}
			if (item.CancelTime) {
				return require(`@/assets/images/box_cancel.svg`);
			}
			var delivery;
			item.Items.forEach(value => {
				delivery = value.Delivery_max;
			});

			if (delivery) {
				var fromDate = parseInt(new Date().getTime() / 1000);
				var toDate = parseInt(new Date(delivery).getTime() / 1000);
				var timeDiff = (toDate - fromDate) / 3600; // will give difference in hrs
				var box = '';

				if (timeDiff > 6) {
					return require(`@/assets/images/box.svg`);
				}
				if (timeDiff > 1 && timeDiff <= 6) {
					return require(`@/assets/images/box_warning.svg`);
				}
				if (timeDiff <= 1) {
					return require(`@/assets/images/box_late.svg`);
				}
				return require(box);
			} else {
				return require(`@/assets/images/box.svg`);
			}
		},

		getImageMarketplace(img) {
			var logo = '';
			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			let payload = this.form;
			try {
				this.preload = true;
				var response = await this.fetchUsers(payload);
			} catch (err) {
				console.log(err);
			}
			this.preload = false;
		},

		deleteItem(item) {
			this.dialogconfirm = true;

			this.form = item;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			this.preload = true;
			let url = 'auth/delete';

			this.messages = [];

			axios
				.delete(`${this.getUrl}${url}/${this.form._id}`, { headers: { Authorization: `Bearer ${this.getToken}` } })

				.then(res => {
					const index = this.items.indexOf(this.form);
					this.items.splice(index, 1);
					this.deleteitem = '';
					this.snackbar.color = 'success';
					this.snackbar.text = 'Utente Eliminato con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					//confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
					//this.form.permission=pluck(res.data.permissions,id);
					this.preload = false;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							console.log(errors);
							errors.forEach(value => {
								console.log(value.msg);
								this.messages[value.param] = value.msg;
							});
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
	},
	beforeDestroy() {
		this.destroyData();
		//clearInterval(this.setinterval)

		//console.log('Main Vue destroyed')
	},
};
</script>

<style></style>
<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.agent-order-cards,
.agent-order-cards tr {
	display: block;
	width: 100%;
}
.agent-order-cards tr,
.agent-order-cards tr:hover {
	background: transparent !important;
}
.agent-order-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.agent-order-cards tr:first-child td {
	padding-top: 12px !important;
}
.agent-order-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.agent-order-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
.order-buyer {
	font-weight: 600;
}
/* dettaglio ordine dentro la card (il "+") */
.order-section {
	font-size: 0.75rem;
	font-weight: 700;
	text-transform: uppercase;
	color: rgba(0, 0, 0, 0.6);
	margin-bottom: 4px;
}
.order-line {
	background: #f7f8fa;
	border-radius: 6px;
	padding: 8px 10px;
	font-size: 14px;
	word-break: break-word;
}
.order-line + .order-line {
	margin-top: 6px;
}
.order-kv {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px;
	color: rgba(0, 0, 0, 0.6);
}
.order-kv-v {
	color: rgba(0, 0, 0, 0.87);
	text-align: right;
	word-break: break-word;
}
</style>
